import React from 'react';
import { useNavigate } from 'react-router-dom';

import { ProgressGauge } from '../../reusables/ProgressGauge';

import { getDateString } from '../../../helpers/utility';

import { IJobApplicantsListTableProps, IColumnProps } from '../../../interfaces/tables';
import { TProgressGaugeColor } from '../../../interfaces/types';
import { IJobApplicationListItem } from '../../../interfaces/services';
import { JobPostDetailsTab } from '../../../interfaces/job_posts';

const JobApplicantsList = (props: IJobApplicantsListTableProps) => {
    const { isLoading, jobApplications } = props;

    const navigate = useNavigate();

    const onRowHover = (index: number) => {
        const progressGauge = document.getElementById(`immployer__list_table__progress_gauge_${index}`);
        if (progressGauge) {
            const progressGaugeBody = progressGauge.querySelector('.immployer__progress_gauge__body');
            if (progressGaugeBody) {
                (progressGaugeBody as HTMLElement).style.backgroundColor = 'var(--immployer__colors__white)';
            }

            const progressGaugeCover = progressGauge.querySelector('.immployer__progress_gauge__cover');
            if (progressGaugeCover) {
                (progressGaugeCover as HTMLElement).style.backgroundColor = 'var(--immployer__colors__primary__50)';
            }
        }
    }

    const onRowLeave = (index: number) => {
        const progressGauge = document.getElementById(`immployer__list_table__progress_gauge_${index}`);
        if (progressGauge) {
            const progressGaugeBody = progressGauge.querySelector('.immployer__progress_gauge__body');
            if (progressGaugeBody) {
                (progressGaugeBody as HTMLElement).style.backgroundColor = 'var(--immployer__colors__primary__50)';
            }

            const progressGaugeCover = progressGauge.querySelector('.immployer__progress_gauge__cover');
            if (progressGaugeCover) {
                (progressGaugeCover as HTMLElement).style.backgroundColor = 'var(--immployer__colors__white)';
            }
        }
    }

    const columns: IColumnProps[] = [
        { name: "Applicant Name", sort: false, identifier: 'name', buttonClass: 'btn_block' },
        { name: "Email", sort: false, identifier: 'email', buttonClass: 'btn_block' },
        { name: "Job Title", sort: false, identifier: 'job_title', buttonClass: 'btn_block' },
        { name: "Applied To", sort: false, identifier: 'applied_to', buttonClass: 'btn_block' },
        { name: "Job Match", sort: false, identifier: 'match', buttonClass: 'btn_block' },
        { name: "Submission Date", sort: false, identifier: 'submission', buttonClass: 'btn_block' },
        { name: "Resume", sort: false, identifier: 'resume', buttonClass: 'btn_block' },
        { name: "Cover Letter", sort: false, identifier: 'cover_letter', buttonClass: 'btn_block' },
        // { name: "", sort: false, identifier: 'actions', buttonClass: 'btn_block' },
    ];

    const onRowClick = (jobApplication: IJobApplicationListItem) => {
        navigate(`/job-portal/${jobApplication.job_post_id}/details`, {
            state: {
                currentTab: JobPostDetailsTab.APPLICANTS,
            }
        });
    }

    const renderRow = (jobApplication: IJobApplicationListItem, index: number) => {
        const getJobMatchColor = (jobMatch: number): TProgressGaugeColor => {
            if (jobMatch >= 80) return 'green';
            if (jobMatch >= 50) return 'yellow';
            if (jobMatch >= 20) return 'orange';
            return 'red';
        }

        const gauge = {
            value: jobApplication.match,
            valueType: 'percentage',
            color: getJobMatchColor(jobApplication.match),
            percentage: jobApplication.match,
        }
        return (
            <tr key={index} onClick={() => onRowClick(jobApplication)} onMouseEnter={() => onRowHover(index)} onMouseLeave={() => onRowLeave(index)}>
                <td>{jobApplication.name}</td>
                <td>{jobApplication.email}</td>
                <td>{jobApplication.job_title}</td>
                <td>{jobApplication.applied_to}</td>
                <td id={`immployer__list_table__progress_gauge_${index}`} className='immployer__list_table__progress_gauge'>
                    <ProgressGauge percentage={gauge.percentage} color={gauge.color}>
                        <div className='immployer__list_table__progress_gauge__content'>
                            <p className='immployer__list_table__progress_gauge__content__p'>{gauge.value}{gauge.valueType === 'percentage' && <span>%</span>}</p>
                        </div>
                    </ProgressGauge>
                </td>
                <td>{getDateString(jobApplication.submission, "MMM DD-YYYY")}</td>
                <td className='immployer__list_table__link'>
                    <a href={jobApplication.resume.url} rel='noreferrer' target='_blank'>
                        {jobApplication.resume.title}
                    </a>
                </td>
                <td className='immployer__list_table__link'>
                    {jobApplication.cover_letter?.title && (
                        <a href={jobApplication.cover_letter.url} rel='noreferrer' target='_blank'>
                            {jobApplication.cover_letter.title}
                        </a>
                    )}
                </td>
                {/* <td >
                        <button>
                            <SVGIcon src={Icons.ThreeDotsVertical} color='grey' />
                        </button>
                </td> */}
            </tr>
        )
    }

    const renderTable = () => {
        if (isLoading) {
            return (
                <tr>
                    <td colSpan={columns.length}>
                        <div className="display_flex flex_dir_column display_flex_center">
                            <span className="wt_600 pb_10">Loading</span>
                            <i className='immployer__list_loader' />
                        </div>
                    </td>
                </tr>
            )
        }

        if (!jobApplications?.length) {
            return (
                <tr>
                    <td colSpan={columns.length} className='text_center'>
                        No records found.
                    </td>
                </tr>
            )
        }

        return jobApplications.map((jobApplication, index) => renderRow(jobApplication, index));
    }

    return (
        <div className="immployer__list_table__container">
            <table className="immployer__list_table">
                <thead>
                    <tr>
                        {columns.map((column, index) =>
                            <th key={index}>
                                <div>
                                    <button className={`${column.buttonClass ?? ''}`}>
                                        {column.name}
                                    </button>
                                </div>
                            </th>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {renderTable()}
                </tbody>
            </table>
        </div>
    );
}

export default JobApplicantsList;